var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { padding: "5px 0" } },
      [
        _c(
          "el-form",
          { attrs: { disabled: !_vm.isEdit, inline: "", "label-width": "0" } },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.DateOfDeparture") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("ETD")))]
                    )
                  ]
                ),
                _c("el-date-picker", {
                  class: _vm.isDifferent("etd"),
                  staticStyle: { width: "200px" },
                  attrs: { no: "10", type: "date", format: "yyyy-MM-dd" },
                  model: {
                    value: _vm.cargoDoc.etd,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "etd", $$v)
                    },
                    expression: "cargoDoc.etd"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.AMSNumber") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("AMS NO")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("hblNbr2"),
                  staticStyle: { width: "200px" },
                  attrs: { no: "11" },
                  model: {
                    value: _vm.cargoDoc.hblNbr2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "hblNbr2", $$v)
                    },
                    expression: "cargoDoc.hblNbr2"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#0000FF" },
                        attrs: { title: "MBL号码" }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("MB/L NO")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("mbl"),
                  staticStyle: { width: "200px" },
                  attrs: { no: "12" },
                  model: {
                    value: _vm.cargoDoc.mbl,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "mbl", $$v)
                    },
                    expression: "cargoDoc.mbl"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: { title: _vm.$t("SeaExport.BillOfLadingType") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("B/L Type")))]
                    )
                  ]
                ),
                _c(
                  "el-select",
                  {
                    class: _vm.isDifferent("amsBlType"),
                    staticStyle: { width: "200px" },
                    attrs: { no: "13", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.cargoDoc.amsBlType,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "amsBlType", $$v)
                      },
                      expression: "cargoDoc.amsBlType"
                    }
                  },
                  _vm._l(_vm.AmsBLType, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.ArrivalDate") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("ETA")))]
                    )
                  ]
                ),
                _c("el-date-picker", {
                  class: _vm.isDifferent("eta"),
                  staticStyle: { width: "200px" },
                  attrs: {
                    no: "14",
                    type: "date",
                    "value-format": "yyyy-MM-dd"
                  },
                  model: {
                    value: _vm.cargoDoc.eta,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "eta", $$v)
                    },
                    expression: "cargoDoc.eta"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.ShippingType") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipment Type")))]
                    )
                  ]
                ),
                _c(
                  "el-select",
                  {
                    class: _vm.isDifferent("shipmentTypeCode"),
                    staticStyle: { width: "200px" },
                    attrs: { no: "15", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.cargoDoc.shipmentTypeCode,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "shipmentTypeCode", $$v)
                      },
                      expression: "cargoDoc.shipmentTypeCode"
                    }
                  },
                  _vm._l(_vm.ShipmentTypeCode, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.CountryOfOrigin") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("County Of Origin")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("countryOrigin"),
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.cargoDoc.countryOrigin,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "countryOrigin", $$v)
                    },
                    expression: "cargoDoc.countryOrigin"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.HtsCode") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("Hts Code")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("hsCode"),
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.cargoDoc.hsCode,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "hsCode", $$v)
                    },
                    expression: "cargoDoc.hsCode"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          width: "105px",
                          "padding-left": "10px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.$t("SeaExport.DischargingPort")
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("POD")))]
                        )
                      ]
                    ),
                    _c("cargo-advance-select", {
                      class: _vm.isDifferent("dischargingPortCode"),
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                        "default-value": _vm.cargoDoc.dischargingPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.podPortChange(
                            p,
                            "dischargingPortCode",
                            "dischargingPort"
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("el-input", {
                  class: _vm.isDifferent("dischargingPort"),
                  staticStyle: { width: "200px", "margin-left": "105px" },
                  model: {
                    value: _vm.cargoDoc.dischargingPort,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "dischargingPort", $$v)
                    },
                    expression: "cargoDoc.dischargingPort"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { display: "inline-block", width: "105px" }
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: { title: _vm.$t("SeaExport.DeliveryPlace") }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getItemTitle("Place Of Delivery"))
                            )
                          ]
                        )
                      ]
                    ),
                    _c("cargo-advance-select", {
                      class: _vm.isDifferent("destinationPortCode"),
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                        "default-value": _vm.cargoDoc.destinationPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.portChange(
                            p,
                            "destinationPortCode",
                            "destinationPort"
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("el-input", {
                  class: _vm.isDifferent("destinationPortCode"),
                  staticStyle: { width: "200px", "margin-left": "105px" },
                  model: {
                    value: _vm.cargoDoc.destinationPort,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "destinationPort", $$v)
                    },
                    expression: "cargoDoc.destinationPort"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "section", staticStyle: { height: "540px" } }, [
      _c(
        "span",
        {
          staticClass: "title",
          attrs: { title: _vm.$t("SeaExport.CustomerShippingInformation") }
        },
        [_vm._v(_vm._s(_vm.getItemTitle("Customer Delivery Info")))]
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabBookingParty",
                    label: _vm.getItemTitle("Booking party"),
                    title: _vm.$t("SeaExport.OriginalBookingParty")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabBookingParty",
                    attrs: {
                      "party-type": "BKP",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabShipToParty",
                    label: _vm.getItemTitle("Container ShipTo Party"),
                    title: _vm.$t("SeaExport.CargoReceiver")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabShipToParty",
                    attrs: {
                      "party-type": "ST",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }